import { createContext, useContext, useMemo, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
const ExamContext = /*#__PURE__*/createContext({
  showExpiredModal: false,
  setShowExpiredModal: () => undefined,
  showExamRules: false,
  setShowExamRules: () => undefined
});
export const ExamContextProvider = ({
  children
}) => {
  const [showExamRules, setShowExamRules] = useState(false);
  const [showExpiredModal, setShowExpiredModal] = useState(false);
  const providerValue = useMemo(() => ({
    showExamRules,
    setShowExamRules,
    showExpiredModal,
    setShowExpiredModal
  }), [showExamRules, showExpiredModal]);
  return /*#__PURE__*/_jsx(ExamContext.Provider, {
    value: providerValue,
    children: children
  });
};
export function withExamContextProvider(WrappedComponent) {
  return props => {
    return /*#__PURE__*/_jsx(ExamContextProvider, {
      children: /*#__PURE__*/_jsx(WrappedComponent, Object.assign({}, props))
    });
  };
}
export const useExpiredModalState = () => {
  const {
    showExpiredModal,
    setShowExpiredModal
  } = useContext(ExamContext);
  return useMemo(() => ({
    showExpiredModal,
    setShowExpiredModal
  }), [setShowExpiredModal, showExpiredModal]);
};
export const useExamRulesState = () => {
  const {
    showExamRules,
    setShowExamRules
  } = useContext(ExamContext);
  return useMemo(() => ({
    showExamRules,
    setShowExamRules
  }), [setShowExamRules, showExamRules]);
};